<template>
    <div class="section-categoryBarBox bread">
        <div class="section-categoryBarCont">
            <div class="section-categoryBarBgg">
                <div class="section-categoryBar">
                    <div class="section-categoryBar__menu">
                        <v-breadcrumbs :items="breadcrumbs">
                            <template v-slot:divider>
                                <v-icon>mdi-chevron-right</v-icon>
                            </template>
                        </v-breadcrumbs>
                    </div>

                    <search-catalog-bar/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {VBreadcrumbs} from 'vuetifyComponents/VBreadcrumbs'; // alias

export default {
    name: "BreadcrumbsBar",

    components: {VBreadcrumbs},

    props: ['breadcrumbs'],
}
</script>

<style lang="sass">
@import "sass/components/BreadcrumbsBar"
</style>